export default "__VITE_ASSET__DdUo09ol__"